import { Button, Modal, TextAreaInput, TextInput } from '@octano/global-ui';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import { DegreeDocumentFormValues } from '../types';
import { useValidations } from '../../../../../../../hooks/useValidations';
import { CardTitle } from '../../../../../../../components/text';

interface Props {
  toggleDialog: () => void;
  append: (value: DegreeDocumentFormValues) => void;
}

const DEFAULT_VALUES = {
  name: '',
  code: '',
  description: '',
};

export const AddDocumentModal = ({ toggleDialog, append }: Props) => {
  const prefix = 'studyPlans.curriculum.degreeDocuments.modal';
  const { t } = useTranslation();
  const { validateTextNotEmpty } = useValidations();

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: DEFAULT_VALUES,
  });

  const onSubmit = useCallback(
    (data: DegreeDocumentFormValues) => {
      append(data);
      toggleDialog();
    },
    [append, toggleDialog],
  );

  return (
    <Modal isOpen toggle={toggleDialog} size="lg" closeOnBackdrop={false}>
      <Container>
        <Row>
          <Col xs={12}>
            <CardTitle textCenter>{t(`${prefix}.title`)}</CardTitle>
            <p className="fs-16 mt-3 mb-4 mx-5  text-center">
              {t(`${prefix}.subtitle`)}
            </p>
          </Col>
        </Row>

        <Row xs={12} className="mt-3">
          <Col xs={12}>
            <TextInput
              name="name"
              control={control}
              label={t(`${prefix}.form.name`)}
              placeholder={t(`${prefix}.form.name`)}
              rules={{ validate: validateTextNotEmpty }}
            />
          </Col>
          <Col xs={12}>
            <TextInput
              name="code"
              control={control}
              label={t(`${prefix}.form.code`)}
              placeholder={t(`${prefix}.form.code`)}
              rules={{ validate: validateTextNotEmpty }}
            />
          </Col>
          <Col xs={12}>
            <TextAreaInput
              name="description"
              control={control}
              label={t(`${prefix}.form.description`)}
              placeholder={t(`${prefix}.form.description`)}
              rules={{ validate: validateTextNotEmpty }}
            />
          </Col>
        </Row>
        <Row xs={12} className="mt-5">
          <Col xs={6}>
            <Button
              text={t(`${prefix}.form.btn.cancel`)}
              onClick={toggleDialog}
              fullwidth
              disabled={isSubmitting}
              outlined
            />
          </Col>
          <Col xs={6}>
            <Button
              type="button"
              onClick={() => handleSubmit(onSubmit)()}
              text={t(`${prefix}.form.btn.addDocument`)}
              loading={isSubmitting}
              fullwidth
            />
          </Col>
        </Row>
      </Container>
    </Modal>
  );
};
